import React from 'react'
import { useTranslation } from 'react-i18next'
import { Typogaphy } from 'vnetwork-ui'
import ClockIcons from '@/icons/ClockIcons'

interface Props {
    time?: string | number
    timeFormat?: string // 'minute' | 'hour' | 'day'
}

const TicketSLAInfo: React.FC<Props> = ({ time, timeFormat }) => {
    const { t } = useTranslation()

    if (!time || !timeFormat) return null

    const formatTimeLabel = () => {
        const timeValue = Number(time)
        switch (timeFormat) {
            case 'minute':
                return t('sla-minutes', { count: timeValue })
            case 'hour':
                return t('sla-hours', { count: timeValue })
            case 'day':
                return t('sla-days', { count: timeValue })
            default:
                return `${timeValue} ${timeFormat}`
        }
    }

    return (
        <div className="flex items-center gap-2 px-3 py-2 bg-blue-50 border border-blue-200 rounded-md">
            <ClockIcons className="w-4 h-4 text-blue-600" />
            <div className="flex items-center gap-1">
                <Typogaphy size="small" className="text-blue-700">
                    {t('sla-response-time')}:
                </Typogaphy>
                <Typogaphy size="small" className="text-blue-800 font-semibold">
                    {formatTimeLabel()}
                </Typogaphy>
            </div>
        </div>
    )
}

export default TicketSLAInfo
